import React, { useEffect, useState } from 'react';
import Papa from 'papaparse';
import './Speakers.css';

const Speakers = () => {
    const [speakers, setSpeakers] = useState([]);

    useEffect(() => {
        Papa.parse(`${process.env.PUBLIC_URL}/speakers.csv`, {
            download: true,
            header: true,
            skipEmptyLines: true,
            complete: (result) => {
                setSpeakers(result.data.filter((speaker) => speaker['Speaker Name']));
            },
        });
    }, []);

    return (
        <section id="speakers" className="speakers-section">
            <h2 className="info-title">Speakers &amp; Moderators</h2>
            <p className="speakers-intro">Speakers include:</p>

            <ul className="speakers-grid">
                {speakers.map((speaker) => {
                    const name = speaker['Speaker Name'];
                    const image = `${process.env.PUBLIC_URL}/headshots/${speaker.Image}`;

                    return (
                        <li className="speaker-profile" key={name}>
                            <img
                                className="speaker-image"
                                src={image}
                                alt={name}
                                loading="lazy"
                                decoding="async"
                            />
                            <h3>{name}</h3>
                            <div className="speaker-details">
                                <p>{speaker.Title}</p>
                                <p>{speaker.Affiliation}</p>
                            </div>
                            {speaker.Bio && <p className="speaker-bio">{speaker.Bio}</p>}
                        </li>
                    );
                })}
            </ul>
        </section>
    );
};

export default Speakers;
